import GlossaryLink from '../glossary/GlossaryLink.js';
import GlossaryService from '../glossary/GlossaryService.js';
import React, { useEffect, Component, useRef, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import TranscriptButton from './TranscriptButton.js';
import Popup, { EnlargeImage } from './Popup.js';
import SearchBar from './SearchBar.js';
import { useHistory } from "react-router-dom";
import useAnalytics from './Analytics.js';
import HexDiagram from '../hacks/HexDiagram.js';
import SpinnyWheel from '../hacks/SpinnyWheel.js';
import RenaiEventAttendance from '../hacks/RenaiEventAttendance.js';
import EventDates from '../pages/EventDates.js';
import TableOfContentsSidebar from './TableOfContents.js';
import Countdown from './Countdown.js';
import CardCarousel from './CardCarousel.js';

function ApplyInjections(target, onSearch, data) {
    if (!target) return [];
    var base = document.getElementsByTagName('base')[0].getAttribute('href');
    var newElements = [];

    //activateAbsoluteURLs
    var as = target.getElementsByTagName("a");
    for (var i = 0; i < as.length; i++) {
        var href = as[i].getAttribute("href");
        if (href) {
            if (base != "/")
                href = href.replaceAll(base, "");
            if (href[0] == "/") {
                as[i].setAttribute("href", base + href.substr(1, href.length))
            }
        }
    }

    //activateGlossary
    if (GlossaryService.cachedList) {
        const glossary = GlossaryService.cachedList;
        var glossaryLinks = target.getElementsByClassName("glossary-link");         
        for (var i = 0; i < glossaryLinks.length; i++) {
            var id = glossaryLinks[i].getAttribute("data-entry");
            if (id) {
                for (var j = 0; j < glossary.length; j++) {
                    if (id.toLowerCase() === glossary[j].name.toLowerCase()) {                        
                        newElements.push(ReactDOM.createPortal(<GlossaryLink entry={glossary[j]} />, glossaryLinks[i]));
                        break;
                    }
                }
            }
        }
    }
    //event dates
    var eventDates = target.getElementsByClassName("event-dates");
    for (var i = 0; i < eventDates.length; i++) {
        newElements.push(ReactDOM.createPortal(<EventDates eventDates={data.eventDates} />, eventDates[i]));
    }
    //activateTranscript
    var buttons = target.getElementsByClassName("transcript-button");
    var contents = target.getElementsByClassName("transcript-content");
    for (var i = 0; i < buttons.length; i++) {
        var label = buttons[i].getAttribute("data-label") || "transcript";
        var big = buttons[i].hasAttribute("data-big");
        var paste = buttons[i].hasAttribute("data-paste");
        var hashName = buttons[i].parentNode.getAttribute("id") || "";
        var hidden = !buttons[i].hasAttribute("data-open");
        newElements.push(ReactDOM.createPortal(<TranscriptButton contentblock={contents[i]} label={label} big={big} paste={paste} hidden={hidden} hashName={hashName} />, buttons[i]));
    }

    //activatePopup
    var buttons = target.getElementsByClassName("popup-button");
    var titles = target.getElementsByClassName("popup-title");
    var contents = target.getElementsByClassName("popup-content");
    for (var i = 0; i < buttons.length; i++) {
        let isVideo = titles[i].classList.contains("popup-video");
        let noIcon = titles[i].classList.contains("popup-noicon");
        if(i < titles.length && i < contents.length)
            newElements.push(ReactDOM.createPortal(<Popup title={titles[i].innerHTML} content={contents[i].innerHTML} isVideo={isVideo} hideIcon={noIcon} />, buttons[i]));
    }

    //activateEnlargeImage
    var gridItems = target.getElementsByClassName("grid-item-image"); 
    for (var i = 0; i < gridItems.length; i++) {
        newElements.push(ReactDOM.createPortal(<EnlargeImage item={gridItems[i].innerHTML} image={gridItems[i].getElementsByTagName("img")[0].getAttribute('src')} />, gridItems[i].parentNode));
    }

    //insert searchbars
    var searchbars = target.getElementsByClassName("searchbar-target");
    for (var i = 0; i < searchbars.length; i++) {
        
        const tip = searchbars[i].getAttribute("data-tip") || "Search the L&T Hub";
        const frontpageMode = searchbars[i].hasAttribute("data-frontpage");
        newElements.push(ReactDOM.createPortal(<SearchBar onSearch={onSearch} tip={tip} filter={""} autoFocus={true} fullWidth disableClearButton={true} frontpageMode={frontpageMode} />, searchbars[i]));
    }

    //automatically wrap iframes in responsive div if needed
    //activateIFrames
    var iframes = target.getElementsByTagName("iframe");
    for (var i = 0; i < iframes.length; i++) {
        if (!iframes[i].parentNode.classList.contains("embed-container")) {
            var par = document.createElement("div");
            par.classList.add("embed-container");
            var h = iframes[i].getAttribute("height"), w = iframes[i].getAttribute("width");
            if (h && w)
                par.style.paddingBottom = (100 * (parseFloat("" + h) / parseFloat("" + w))) + "%";
            iframes[i].parentNode.insertBefore(par, iframes[i]);
            par.appendChild(iframes[i]);
        }
    }

    
    //
    var renaiEventAttendances = target.getElementsByClassName("renai-event-action");
    for (var i = 0; i < renaiEventAttendances.length; i++) {
        newElements.push(ReactDOM.createPortal(<RenaiEventAttendance page={data} />, renaiEventAttendances[i]));
    }

    //re-hydrate scripts (they can't normally execute via innerHTML)
    var hexDiagram = document.querySelector(".hex-svg");
    if (hexDiagram) {
        HexDiagram();
    }

    var tocMounts = target.getElementsByClassName("toc-sidebar-mount");
    const headingLevels = ["h1", "h2", "h3", "h4", "h5", "h6"];    
    function createToplink() {
        const toplink = document.createElement("div");

        toplink.className = "toc-toplink";
        toplink.style.cssText =
            "text-align:right; margin-bottom:1em; font-size:0.875rem;";
        toplink.innerHTML =
            '<a href="#toc" aria-label="Back to table of contents">&uarr; Back to contents</a>';

        return toplink;
    }
    for (var i = 0; i < tocMounts.length; i++) {
        var mountNode = tocMounts[i];
        var maxLevel = tocMounts[i].getAttribute("max-level") || 3;        
        var autoNumber = tocMounts[i].getAttribute("data-autonumber") || false;
        var parentWrapper = mountNode.closest(".toc-wrapper") || target;
        const targetHeadingLevels = headingLevels.slice(0, Math.min(headingLevels.length - 1, maxLevel));
        var headings = parentWrapper.querySelectorAll(targetHeadingLevels.join(", "));
        if (headings.length > 0) {
            var headingData = [];
            headings.forEach((heading, index) => {     
                if (!heading.id) {
                    var textSlug = heading.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
                    heading.id = textSlug ? `toc-${textSlug}-${index}` : `toc-heading-${index}`;
                  
                }
                headingData.push({
                    id: heading.id,
                    text: heading.textContent,
                    tagName: heading.tagName.toLowerCase()
                });               
                            
                if (index > 0 && !heading.previousElementSibling?.classList.contains("toc-toplink")) {                   
                    heading.parentNode.insertBefore(createToplink(), heading);
                }
            });
             
            var contentWrapper = parentWrapper.querySelector(".toc-content-pane");
            if (
                !contentWrapper.lastElementChild ||
                !contentWrapper.lastElementChild.classList.contains("toc-toplink")
            ) {
                contentWrapper.appendChild(createToplink());
            }         
          


            newElements.push(
                ReactDOM.createPortal(
                    <TableOfContentsSidebar headings={headingData} autoNumber={autoNumber} />,
                    mountNode
                )
            );
        }
    }

    const countdowns = target.getElementsByClassName("countdown");
    for (var i = 0; i < countdowns.length; i++) {
        const targetDatetime = countdowns[i].getAttribute("data-date-target");
        newElements.push(ReactDOM.createPortal(<Countdown targetDate={targetDatetime || new Date()} />, countdowns[i]));
    }

    const cardCarousels = target.getElementsByClassName("card-carousel");
    for (var i = 0; i < cardCarousels.length; i++) {
        const cards = Array.from(cardCarousels[i].querySelectorAll(".carousel-item")).map((card, i) => {
            card.style.display = "none";
            return {
                id: i,
                title: card.dataset.title || "Title",
                description: card.dataset.description || "This is where the description would go.",
                image: card.dataset.image || "https://lt.uow.edu.au/hub/api/attachment/file/5101/Megan%20Smith%20LT%20Hub.png",
            };
        });
        newElements.push(ReactDOM.createPortal(<CardCarousel items={cards} autoPlay={false} />, cardCarousels[i]));
    }

    const randomBanners = target.getElementsByClassName("random-banner");
    for (var i = 0; i < randomBanners.length; i++) {
        const possibleImageString = randomBanners[i].getAttribute("data-image-options");
        if (possibleImageString) {
            const possibleImages = possibleImageString.split(",");
            const targetImageUrl = possibleImages[Math.floor(Math.random() * possibleImages.length)];
            randomBanners[i].style.backgroundImage = `url('${targetImageUrl}')`;
            randomBanners[i].classList.remove("random-banner");//dont flicker
        }
    }

    var spinnyBoy = document.querySelector(".wheel-anim");
    if (spinnyBoy) {
        SpinnyWheel();
    }

    //tooltip 
    //markup dl/dt/dd with ids
    //copy html content, write a short js script to scan dts and wrap them in custom element using data-glossary-entry=dt.name
    //hijack script will scan for these and use the glossary ids to hookup a mateira ui tooltip with correct description

    return newElements;
}

const NoRouterHijack = (props) => {
    let history = useHistory();
    const injected = useMemo(() => ApplyInjections(props.children.ref.current, (search) => {
        history.push("/search?sort=score&filter=" + search);
    }, props.data), [props.children, history]);

    return (
        <div>{props.children}{injected}</div>
    );
};

const defaultProtocols = ['mailto', 'tel'];
const defaultHostnames = [];
const getRoute = function(url) {
    var getLocation = function (href) {
        // eslint-disable-next-line no-useless-escape
        const re = /^(https?\:)?\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
        const match = href.match(re)
        const location = match && {
            href: href,
            protocol: match[1],
            host: match[2],
            hostname: match[3],
            port: match[4],
            pathname: match[5],
            search: match[6],
            hash: match[7]
        }
        return match && location
    };

    // if it is an explicit non-http protocol, we want the browser to handle it natively
    // using history.push will do bad things
    const protocols = defaultProtocols;
    const hostnames = defaultHostnames;
    const nonHttpProtocol = protocols.some(protocol => url.startsWith(`${protocol}:`))
    if (nonHttpProtocol) { return false; }

    let destination = url;

    var base = document.getElementsByTagName('base')[0].getAttribute('href');
    const isApi = destination.indexOf("/api/") !== -1;
    if (isApi) return false;

    // if it's http or protocol-relative, we need to check further
    // we want to use react router if it's sending us to the same domain
    const re = new RegExp('^(https?:)?//')
    const isHTTP = re.test(url)
    if (isHTTP) {
        const { hostname, pathname, search, hash } = getLocation(url)
        const sameSite = (hostname === window.location.hostname && pathname.indexOf(base) === 0) || hostnames.indexOf(hostname) !== -1
        if (sameSite) {
            destination = pathname
            if (search) { destination += search }
            if (hash) { destination += hash }
        } else {
            // if it's an external http url, we let the browser handle it natively
            return false;
        }
    }

    if (base != "/" && destination.indexOf(base) === 0) {
        destination = destination.replace(base, "/");
    }

    return destination;
}


const Hijack = ({ children, history, data }) => {
    const [injected, setInjected] = React.useState([]);

    useEffect(() => {
        if (!children?.ref?.current) return;

        const elements = ApplyInjections(children.ref.current, (search) => {
            history.push("/search?sort=score&filter=" + search);
        }, data);

        setInjected(elements);
    }, [children, history, data]);

    useEffect(() => {
        return () => setInjected([]);
    }, []);

    const shouldRouterHandle = (url, event) => {
        var destination = getRoute(url);
        if (destination !== false) {
            if (destination[0] === "#") {
                window.location.hash = destination;
                var el = document.getElementById(destination.substring(1));
                if (el)
                    el.scrollIntoView({ behavior: 'smooth' });
            } else {
                if (destination.startsWith(window.location.pathname.substr(0)) || destination.startsWith(window.location.pathname.substr(1))) {
                    history.push(destination);
                    window.location.reload();
                } else {
                    history.push(destination);
                }
            }
            event.preventDefault();
        }
    };

    const onClick = (event) => {
        const { ctrlKey, shiftKey, metaKey } = event;
        if (ctrlKey || shiftKey || metaKey) {
            return;
        }

        const self = event.currentTarget;
        for (let el = event?.target; el !== self; el = el.parentElement) {
            if (!el)
                break;
            if (el.nodeName === 'A') {
                const target = el.getAttribute('target');
                if (target && target !== '_self' && target !== window.name) { return; }
                const href = el.getAttribute('href');
                href && shouldRouterHandle(href, event);
                break;
            }
        }
    };

    return <div onClick={onClick}>{children}{injected}</div>;
};
export default withRouter(Hijack);
export { NoRouterHijack, getRoute };
